import { Box } from '@mui/material';
import { staticContent } from 'components/constants/Constants';
import { useBreakpoints } from 'hooks/useBreakpoints';
import piwik from 'piwik/piwik';
import { Link } from 'react-router-dom';
export type MarketingBannerProps = {
  eventname: string;
  url: string;
  alt: string;
  openInNewTab: boolean;
};
export const MarketingBanner: React.FC<MarketingBannerProps> = props => {
  const imageName = 'mk-banner';
  const { width } = useBreakpoints();

  const imageUrl = (size: 'xl' | 'md' | 'sm') =>
    staticContent + `/banner/${props.eventname}/${imageName}-${size}.png`;
  return (
    <Box
      component={Link}
      target={props.openInNewTab ? '_blank' : '_self'}
      to={props.url}
      onClick={() =>
        piwik.push([
          'trackEvent',
          'Search',
          'clickedMarketingBanner',
          props.eventname
        ])
      }
    >
      <Box
        component="img"
        sx={{
          display: {
            xs: 'block',
            xl: 'none'
          },
          minHeight: '100%',
          objectFit: 'cover',
          maxWidth: '100%'
        }}
        src={width < 768 ? imageUrl('sm') : imageUrl('md')}
        alt={props.alt}
      />

      <Box
        sx={{
          display: {
            xs: 'none',
            xl: 'block'
          },
          backgroundImage: `url('${imageUrl('xl')}')`,
          backgroundRepeat: 'repeat-x',
          backgroundSize: 'auto 80px',
          backgroundPosition: 'center',
          height: 80
        }}
      />
    </Box>
  );
};
